import { loadStripe } from '@stripe/stripe-js'

let stripePromise = null

export function getStripe() {
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  if (!key) {
    console.warn('[stripe] No publishable key — payments disabled')
    return Promise.resolve(null)
  }
  if (!stripePromise) {
    stripePromise = loadStripe(key)
  }
  return stripePromise
}

/**
 * Redirect to Stripe Checkout for the given cart items
 * @param {Array} cartItems - [{id, name, price_cents, quantity, image}]
 * @param {{ label: string, price_cents: number, serviceCode?: string } | null} shippingOption - Pre-selected shipping rate (Shippo carrier or 'custom')
 * @returns {Promise<void>}
 */
export async function redirectToCheckout(cartItems, shippingOption = null) {
  const stripe = await getStripe()
  if (!stripe) {
    throw new Error('Stripe is not configured. Add VITE_STRIPE_PUBLISHABLE_KEY.')
  }

  const payload = { items: cartItems }
  if (shippingOption) payload.shippingOption = shippingOption

  // Create checkout session via serverless function
  const res = await fetch('/api/create-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || `Checkout failed: ${res.status}`)
  }

  const { sessionId, url } = await res.json()

  // Prefer direct URL redirect (faster), fallback to stripe.redirectToCheckout
  if (url) {
    window.location.href = url
  } else if (sessionId) {
    const { error } = await stripe.redirectToCheckout({ sessionId })
    if (error) throw error
  } else {
    throw new Error('No checkout URL returned from server')
  }
}
